export enum SentencePosition {
  sentence1,
  sentence2,
}
